import React, { FormEvent } from 'react';
import { useLocation } from 'react-router-dom';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

import ActionButton from '../buttons/ActionButton';
import { stob64 } from '../../util/stringutils';

declare const STRIPE_REDIRECT_URL: string;

const CheckoutForm = ({ priceId }: { priceId: string }) => {
  const location = useLocation();
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const encodedState = stob64(JSON.stringify({
      location: location.pathname + location.search,
      priceId
    }));

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: `${STRIPE_REDIRECT_URL}?state=${encodedState}`,
      },
    });


    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement/>
      <ActionButton disabled={!stripe}>Submit</ActionButton>
    </form>
  );
};

export default CheckoutForm;
